/**
 * Default timeout interval for command
 */
export const defaultCommandTimeout = 0;

let delayedOperation;

/**
 * Executes command with delay
 * New call wipes out current request in favor of a new one.
 * Used for double click handlers where we want to delay click command in
 * favor of double click to avoid flickering in UI.
 */
export function executeCommand(command: () => void, delay: number) {
    if (delayedOperation) {
        window.clearTimeout(delayedOperation);
    }

    delayedOperation = window.setTimeout(() => {
        command();
        delayedOperation = null;
    }, delay);
}
